import { Falcon } from 'modules/macro';
export function SortIcon(props) {
    const { order } = props;
    if (order === 'asc') {
        return <Falcon icon="square-caret-up" sourceConfig={{ family: 'classic', style: 'solid' }}/>;
    }
    if (order === 'desc') {
        return <Falcon icon="square-caret-down" sourceConfig={{ family: 'classic', style: 'solid' }}/>;
    }
    return null;
}
